const serviceData = [
  {
    imgsrc:
      "https://www.reachfirst.com/wp-content/uploads/2018/08/Web-Development.jpg",
    title: "Web Development",
    info:
      "The only course you need to learn web development - HTML, CSS, JS, Node, and More.Continue to grow as a developer, long after the course ends.",
  },
  {
    imgsrc:
      "https://codelogictechnologies.com/wp-content/uploads/2019/08/android-n.png",
    title: "Android Development",
    info:
      "Learn Android App by building real apps including Uber, Whatsapp and Instagram.Make pretty much any Android App.",
  },
  {
    imgsrc: "https://miro.medium.com/max/6000/1*JUSbO0xkXPf2jtYLMSAZ8w.jpeg",
    title: "Mobile Development",
    info:
      "Create mobile web apps and native Android/iOS apps from a single code base with React, Ionic Framework 5, and Firebase.",
  },
  {
    imgsrc:
      "https://cdn57.androidauthority.net/wp-content/uploads/2019/11/Game-design-and-development-vector-iso.jpg",
    title: "Game Development",
    info:
      "Learn Android Game Development with Android Studio and Java by making a complete Flappy Bird game in SurfaceView",
  },
  {
    imgsrc:
      "https://www.lanner-america.com/wp-content/uploads/IoT-Security-D-1.jpg",
    title: "Security Development",
    info:
      "CISSP Certification Domain 7 & 8 - Learning Security Operations and Software Development and Security in this Course.",
  },
  {
    imgsrc: "https://www.smartsight.in/wp-content/uploads/2017/12/big-data.png",
    title: "Big Data Development",
    info:
      "Big Data Databases Analytics With Hadoop & Apache Spark: Programming, Pig, MySQL & MapReduce For Developers.",
  },
];

export default serviceData;
